import { Suspense } from 'react';
import { TouringTasks } from '@features';
import { AppShell, ScrollArea, Skeleton } from '@mantine/core';
import { ErrorBoundary } from '@sentry/react';
import styles from './Aside.module.css';

export const Aside: React.FC = () => {
  return (
    <AppShell.Section
      bg="layout.1"
      h="100%"
      component={ScrollArea}
      className={styles.asideSection}
    >
      <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<Skeleton height={120} m="md" />}>
          <TouringTasks />
        </Suspense>
      </ErrorBoundary>
    </AppShell.Section>
  );
};
